/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import { IconDownload, IconEye, IconPlus } from "@tabler/icons-react";
import ListView from "../../../components/common/ListView";
import NormalSearch from "../../../components/common/NormalSearch";
import DropdownFilter from "../../../components/common/DropdownFilter";
import ColumnsFilter from "../../../components/common/ColumnsFilter";
import CommonModal from "../../../components/common/CommonModal";
import AddCitiesModal from "./AddCitiesModal";
import CitiesEditViewModal from "./CitiesEditViewModal";
import {
  useCitiesFetchData,
  useCityCreateMutation,
} from "../../../apis/locationApis";
import IntegrationSkeleton from "../../../components/skeleton/IntegrationSkeleton";
import Pagination from "../../../components/common/Pagination";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import formatDate from "../../../utilities/helper";
import useDebounce from "../../../utilities/useDebounce";
import TableSkeleton from "../../../components/skeleton/TableSkeleton";

interface City {
  id: string;
  name: string;
  arabicName: string;
  cityCode: string;
  countryId: string;
  hubId: string;
  country: string;
  hub: string;
}

export default function CitiesListTab() {
  const [credential, setCredential] = useState<boolean>(false);
  const credentialToggleModal = () => {
    setCredential(!credential);
  };
  const [searchFor, setSearchFor] = useState<string>("");
  const [pageNo, setPageNo] = useState<number>(1); // ✅ new state
  const [isOpen, setIsOpen] = useState(false);
  const [city, setCity] = useState<City>({
    id: "",
    name: "",
    arabicName: "",
    cityCode: "",
    countryId: "",
    hubId: "",
    country: "",
    hub: "",
  });

  const { data, isPending, refetch } = useCitiesFetchData(pageNo, searchFor);
  const { mutate, isPending: isRequestPending } = useCityCreateMutation();

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm();

  const debouncedSearchFor = useDebounce(searchFor, 550);

  useEffect(() => {
    refetch(); // Trigger on search or page change
  }, [debouncedSearchFor]);

  const handlePaginationFetch = async (page: number) => {
    setPageNo(page);
    try {
      await refetch();
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch data");
    }
  };

  const handleCityCreate = (data: any) => {
    mutate(
      { ...data, type: 'lmClient' },
      {
        onSuccess: () => {
          setCredential(false);
          refetch();
        },
        onError: (error: any) => {
          console.error(error);
          toast.error(error?.response?.data?.message || "Something went wrong");
        },
      }
    );
  };

  return (
    <>
      <div className="bg-[#F7F6F2] rounded-3xl">
        <div className="flex justify-between items-center w-full  p-4">
          <div className="flex justify-between items-center  rounded-tl-3xl rounded-tr-3xl">
            <h1 className="text-3xl text-[#212121]">Cities</h1>
          </div>
          <div className=" flex items-center gap-2 justify-end rounded-full">
            <div className="flex items-center gap-2">
              <ColumnsFilter columnsData={[]} />
              <DropdownFilter filterheadings={[]} />
              <NormalSearch
                value={searchFor}
                onChange={(e) => {
                  setSearchFor(e.target.value);
                  setPageNo(1); // Reset to page 1 on search
                }}
              />
            </div>

            <button
              onClick={credentialToggleModal}
              className="flex items-center gap-1  p-2 text-sm rounded-full border border-[#D8D8D8] bg-white"
            >
              <IconPlus />
            </button>
            <button className="flex items-center gap-1 py-2 px-4 text-sm rounded-full border border-[#D8D8D8] bg-white">
              <IconDownload /> Export
            </button>
          </div>
        </div>
        <div>
          {isPending ? (
            <TableSkeleton
              columns={[
                "S/N",
                "City Name",
                "City Code",
                "City Arabic Name",
                "Country Name",
                "Created Date",
                "Actions",
              ]}
              rows={6}
            />
          ) : (
            <ListView
              data={data?.cities}
              onRowClick={(client) => console.log("Clicked:", client)}
              columns={[
                { label: "S/N", render: (_, i) => i + 1 },
                { label: "City Name", render: (c: any) => c.name },
                { label: "City Code", render: (c: any) => c.cityCode },
                { label: "City Arabic Name", render: (c: any) => c.arabicName },
                { label: "Country Name", render: (c: any) => c.country },
                {
                  label: "Created Date",
                  render: (c: any) => formatDate(c.date),
                },
                {
                  label: "Actions",
                  render: (c: any) => (
                    <button
                      onClick={() => {
                        setIsOpen(true);
                        setCity(c);
                      }}
                      className="p-2 border rounded-full bg-[#F7F6F2]"
                    >
                      <IconEye />
                    </button>
                  ),
                },
              ]}
            />
          )}
        </div>

        {data?.totalPages > 1 && (
          <Pagination
            totalPages={data.totalPages}
            fetchData={handlePaginationFetch}
            currentPage={pageNo}
          />
        )}
      </div>
      <CommonModal
        title={"Add Cities"}
        open={credential}
        closeButtonText={"Cancel"}
        onClose={credentialToggleModal}
        actionButtonText="Add Cities"
        // actionButtonOnClick={credentialToggleModal}
        actionButtonOnClick={handleSubmit(handleCityCreate)}
        actionButtonProps={{ disabled: isRequestPending }}
      >
        <AddCitiesModal register={register} errors={errors} watch={watch} />
      </CommonModal>
      <CitiesEditViewModal
        open={isOpen}
        onClose={closeModal}
        city={city}
        setCity={setCity}
        fetchData={refetch}
      />
    </>
  );
}
